<div class="pos-panel">
    <div class="pos-panel-header">
        <span class="soc-panel-header">{{'NAVBAR.SERVICE' | translate}}</span>
        <hr class="soc-panel-line"/>
    </div>
    <div class="d-flex justify-content-between">
        <span class="soc-h4">{{'GROUPS.GROUPS' | translate}}</span>
    </div> 
    <hr class="soc-panel-line"/>
    <div *ngIf="groups?.length == 0 && searchTerm == '' && !loading" class="pos-no-entities-wrapper">
        <div class="pos-no-entities-indicator" style="width: 491px;">
            <span class="material-icons pos-no-entities-icon">room_service</span>
            <span class="soc-h2 text-center">{{'GROUPS.GROUPS' | translate}}</span>
            <span class="soc-p text-center">{{'GROUPS.CREATE_GROUP_TEXT' | translate}}</span>
            <button class="soc-basic-cyan-btn" (click)="addNewGroup()">{{'GROUPS.CREATE_GROUP_BTN' | translate}}</button>
        </div>
    </div>
    <div class="soc-wrapper-gap-24-column" *ngIf="groups && (groups.length > 0 || searchTerm != '' || loading)">
        <div class="pos-actions-wrapper">
            <div class="soc-search-wrapper">
                <div class="p-inputgroup soc-search-field-wrapper">
                    <i class="pi pi-search soc-neutral-text-color"></i>
                    <input type="text" class="soc-search-input-field soc-input-text" [(ngModel)]="searchTerm" (ngModelChange)="searchTermChange()" placeholder="{{'SEARCH' | translate}}">
                </div>
            </div>
            <button class="soc-basic-cyan-btn" (click)="addNewGroup()"><span class="material-icons">room_service</span>{{'GROUPS.NEW' | translate}}</button>
        </div> 
        <hr class="soc-panel-line"/>
    </div>
    <div *ngIf="!groups || loading" class="soc-loading-wrapper">
        <p-progressSpinner strokeWidth="4"></p-progressSpinner>
    </div>   
    <div *ngIf="groups && groups.length > 0 && !loading" class="pos-panel-cards-wrapper">
        <ng-container *ngFor="let group of groups"> 
        <div class="soc-card">
                <span class="material-icons soc-img-placeholder">room_service</span>
                <div class="soc-card-info">
                    <div class="d-flex justify-content-between w-100">
                        <div class="soc-card-title">
                            <span class="soc-h2">{{group.name}}</span>
                        </div>
                        <span class="material-icons neutral-90" (click)="$event.stopPropagation(); actionMenu.toggle($event)">more_vert</span>
                        <p-overlayPanel #actionMenu [dismissable]="true" class="d-none">
                            <div class="soc-action-menu-content">
                                <div class="soc-action-item" (click)="editGroup(group)">{{'GROUPS.EDIT' | translate}}</div>
                                <div class="soc-action-item" (click)="deleteGroup(group)">{{'GROUPS.DELETE' | translate}}</div>
                            </div>
                        </p-overlayPanel>
                    </div>
                    <div class="soc-wrapper-gap-12-column w-100">
                        <div class="soc-card-subtitle">
                            <span class="soc-display-lbl w-100">{{'GROUPS.MENU_CATEGORIES' | translate}}</span>  
                            <span class="soc-text soc-cyan-color w-100 text-end"> {{group.servingAreMenuCategories?.length}} {{'GROUPS.CATEGORIES_ASSIGNED' | translate}}</span>  
                        </div>
                        <hr class="soc-split-line">
                        <div class="soc-card-content align-items-center">
                            <ng-container *ngFor="let category of group.servingAreMenuCategories">
                                <span>{{category.menuCategory?.name}}</span>
                                <i class="pi pi-circle-fill soc-numbering-dot" style="padding-right: 4px;padding-left: 4px;"></i>
                            </ng-container>
                        </div>
                    </div>
                </div>
        </div> 
        </ng-container>  
    </div>
</div>
<p-confirmDialog class="soc-confirmation-dialog"></p-confirmDialog>
<p-toast position="top-center"></p-toast>
 